import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import type { ComponentProps } from "react";
import { Drawer as DrawerPrimitive } from "vaul";

import { cn } from "../../utils/cn.util";
import { isToastInteraction } from "../toast/is-toast-interaction";

const Content = ({
  ref,
  className,
  children,
  onPointerDownOutside,
  ...props
}: ComponentProps<typeof DrawerPrimitive.Content>) => (
  <DrawerPrimitive.Content
    aria-describedby={undefined}
    ref={ref}
    className={cn(
      "group/drawer-content bg-background fixed z-50 flex h-auto flex-col bg-white",
      "data-[vaul-drawer-direction=top]:inset-x-0 data-[vaul-drawer-direction=top]:top-0 data-[vaul-drawer-direction=top]:max-h-[80vh]",
      "data-[vaul-drawer-direction=bottom]:inset-x-0 data-[vaul-drawer-direction=bottom]:bottom-0 data-[vaul-drawer-direction=bottom]:max-h-[80vh]",
      "data-[vaul-drawer-direction=right]:inset-y-0 data-[vaul-drawer-direction=right]:right-0",
      "data-[vaul-drawer-direction=left]:inset-y-0 data-[vaul-drawer-direction=left]:left-0",
      className
    )}
    onPointerDownOutside={event => {
      if (isToastInteraction(event)) {
        event.preventDefault();
        return;
      }
      onPointerDownOutside?.(event);
    }}
    {...props}
  >
    <VisuallyHidden>
      <DrawerPrimitive.Title />
    </VisuallyHidden>
    {children}
  </DrawerPrimitive.Content>
);

Content.displayName = "Content";

export default Content;
